<script>
import ChannelSelector from '../ChannelSelector.vue';
export default {
  components: { ChannelSelector },
  props: {
    channel: {
      type: Object,
      required: true,
    },
    enabledFeatures: {
      type: Object,
      required: true,
    },
  },
  emits: ['channelItemClick'],
  computed: {
    hasFbConfigured() {
      return window.chatwootConfig?.fbAppId;
    },
    isActive() {
      const { key } = this.channel;
      if (Object.keys(this.enabledFeatures).length === 0) {
        return false;
      }
      if (key === 'website') {
        return this.enabledFeatures.channel_website;
      }
      if (key === 'facebook') {
        return this.enabledFeatures.channel_facebook && this.hasFbConfigured;
      }
      if (key === 'email') {
        return this.enabledFeatures.channel_email;
      }

      return [
        'website',
        'twilio',
        'api',
        'whatsapp',
        'sms',
        'telegram',
        'line',
        'gupshup',
        'whatsappweb',
        'mercadolibre',
        'marcatel',
        'facebookcomments',
      ].includes(key);
    },
  },
  methods: {
    getChannelThumbnail() {
      if (this.channel.key === 'api' && this.channel.thumbnail) {
        return this.channel.thumbnail;
      }
      if (this.channel.key === 'gupshup') {
        return "/assets/images/dashboard/channels/whatsapp.png";
      }
      if (this.channel.key === 'whatsappweb') {
        return "/assets/images/dashboard/channels/whatsapp_basic.png";
      }
      if (this.channel.key === 'mercadolibre') {
        return "/assets/images/dashboard/channels/mercadolibre.png";
      }
      if (this.channel.key === 'marcatel') {
        return "/assets/images/dashboard/channels/marcatel.png";
      }
      if (this.channel.key === 'facebookcomments') {
        return "/assets/images/dashboard/channels/facebookcomments.png";
      }
      return `/assets/images/dashboard/channels/${this.channel.key}.png`;
    },
    onItemClick() {
      if (this.isActive) {
        this.$emit('channelItemClick', this.channel.key);
      }
    },
  },
};
</script>

<template>
  <ChannelSelector
    :class="{ inactive: !isActive }"
    :title="channel.name"
    :src="getChannelThumbnail()"
    @click="onItemClick"
  />
</template>
